import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    ESTIMATE_USER_ENGAGEMENT: (userIds) => ({ userIds }),
    API: {
      ESTIMATE_USER_ENGAGEMENT: apiResourceActionCreator('estimations')
    }
  }
})

export const apiAction = (authToken, userIds) => commonApiActions.authenticated.post(`${API_ENDPOINT}/estimateUserEngagement`, authToken, userIds, action.admin.api.estimateUserEngagement)

function* estimateUserEngagement(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.userIds));
}

const configuration = {
  name: 'estimateUserEngagement',
  action: action,
  sagas: estimateUserEngagement,
  reducers: {
    request: (state, action) => ({
      ...state,
      isEstimatingUserEngagement: true
    }),
    success: (state, action) => {
      const result = action.payload.estimations
      const updatedUserIds = fp.map(
        fp.get('user.id')
      )(result)
      const userEngagementEstimations = state.userEngagementEstimations
      const updatedEstimations = fp.flow(
        fp.filter(
          ({ user }) => !fp.includes(user.id)(updatedUserIds)
        ),
        fp.concat(result)
      )(userEngagementEstimations)
      return ({
        ...state,
        isEstimatingUserEngagement: false,
        userEngagementEstimations: updatedEstimations
      })
    },
    failed: (state, action) => ({
      ...state,
      isEstimatingUserEngagement: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/estimateUserEngagement.js